import NavigationHeder from "../../../components/Navigations/NavigationHeder";
import WorkflowVersions from '../Workflow Versions/WorkflowVersions';
import { useCallback, useEffect, useState } from 'react';
import NewWorkflow from '../New Workflow/NewWorkflow';
import Button from '../../../components/inc/Button';
import axios from 'axios';
import Settings from '../../../inc/Settings';
import Helper from "../../../inc/Helper";
import Api from "../../../inc/Api";
import TriggerOption from "../Trigger/TriggerOption";
import { Tab, Tabs } from "react-bootstrap";
import MasterComponentWraper from "../../../components/Backend/MasterComponentWraper";
import { connect } from "react-redux";
import AgGridNew from "../../../components/grid/ag/ag-grid-new";
import { exportToXlsx, getPopupMessageBasedOnStatus } from "../../../inc/Validation";
import { generateBaseUrl, getLabelFromDropdown, getOptions, optionsKeyCreator } from "../../../components/grid/ag/commonFunctions/GridCommonFunctions";
import NewOverlayLoader from "../../../components/PurchaseRequisition/common/NewOverlayLoader";
import { transformObjectWorkflows } from "../../../inc/TransformerFunctions";
import { useNavigate } from "react-router-dom";

let gridApiActive = null;
const Workflow = (props) => {
  const [tab, setTab] = useState('Active');
  const [templateData, setTemplateData] = useState([]);
  const [dropdownTemplates, setDropdownTemplates] = useState([]);
  const [workflowVersionsModal, setWorkflowVersions] = useState((localStorage.getItem("isWorkflowversion") && localStorage.getItem("isWorkflow"))?localStorage.getItem("isWorkflowversion"):false);
  const [newWorkflowModal, setNewWorkflow] = useState(false); 
  const navigate = useNavigate();

  const [exportLoading, setExportLoading] = useState(false);

  useEffect(() => {
    if (props?.user?.admin_user === true) {
      navigate('/template');
    }
  }, [props?.user]);

  useEffect(() => {
    getTemplateData();
  }, []);

  useEffect(() => {
    refreshParentGrid();
  }, [newWorkflowModal, workflowVersionsModal]);

  useEffect(() => {
    refreshParentGrid();
  }, [workflowVersionsModal]);

  const getTemplateData = () => {
    const api = Api;
    api.setUserToken();
    api.axios().get(Settings.baseUrl + 'template/get-all').then((res) => {
      if (res.data.success) {
        setDropdownTemplates(res?.data?.data?.map(item => {
          return {
            value: item.template_id,
            label: item.name
          }
        }));
        setTemplateData(res?.data?.data);
      };
    })
  };

  const getAllWorkflowData = (templateid) => {
    return new Promise((resolve, reject) => {
      resolve(
        axios.get(Settings.baseUrl + `workflow/get-version?template_id=${templateid}&tenant_id=${props?.user?.tenant_id}`).then((res) => {
          if (res.data.success) {
            let data;
            data = res.data.data.filter(element => {
              return element.active;
            })
            return data;
          }
        })).catch((error) => reject(
          console.log(error)
        ))
    })
  };
  
  const refreshParentGrid = () => {
    gridApiActive?.api?.refreshServerSide({ purge: true });
    gridApiActive?.api?.deselectAll();
  };
 
  const redirectValueFormatter = (params) => {
    return `<span class="rs_active_label">${params.value}</span>`;
  }

  const gridColumnHeader = [
    { field: 'workflow_id', headerName: 'Workflow ID' },
    { field: 'name', headerName: 'Name', width: 350 },
    { field: 'description', headerName: 'Description', width: 350 },
    {
      field: 'template_id',
      headerName: 'Template',
      editable: false, 
      isAllowZero: true,
      inputId: 'template_id',
      minWidth:180,
      cellEditorParams: {
        values: dropdownTemplates
      },
      cellDataType:false,
      valueFormatter: (params)=> getLabelFromDropdown(params),
      filter: 'agSetColumnFilter',
      filterParams: {
        values: (params) => getOptions(params, dropdownTemplates),
        keyCreator: (params) => optionsKeyCreator(params, 'value'),
        valueFormatter: params => params.value.label
      }
    }, 
    { field: 'instance', headerName: 'Instances', width: 250 },
    { field: 'version', headerName: 'Versions', width: 250 },
    // { field: 'viewOrEdit', headerName: 'Action', cellRenderer: CustomHtmlCell, valueFormatter: redirectValueFormatter }
  ]
 
  // const workflowDeleteWithAllVersion = () => {
  //   if (!workflowid) {
  //     Helper.alert("Please select atleast one wrokflow", 'error');
  //     return;
  //   }
  //   $('.rs_form_grid .btn_delete').trigger('click');
  // }

  const [templateid, setTemplateid] = useState((localStorage.getItem("isWorkflowversion") && localStorage.getItem("isWorkflow"))?localStorage.getItem("templateId"):null);
  const [workflowid, setWorkflowid] = useState(null);

  const getRowData = (event) => {
    let activeSelection = event.api.getSelectedRows();
    if (activeSelection.length) {
      setTemplateid(activeSelection[0].template_id);
      setWorkflowid(activeSelection[0].workflow_id);
    } else {
      setTemplateid(null);
      setWorkflowid(null);
    }
  }

  const workflowVersionHandler = () => {
    if (!templateid) {
      Helper.alert("Please select atleast one workflow", 'error');
      return;
    }
    setWorkflowVersions(true);
    setWorkflowid(null);
  }

  //all type of trigger execution on trigger modal 

  const [triggerOption, setTriggerOption] = useState(false);

  const designHandler = () => {
    if (!workflowid) {
      Helper.alert("Please select atleast one workflow", 'error');
      return;
    }
    setTriggerOption(true);
  }

  const workflowActiveHandler = () => {
    if (!workflowid && tab==="Inactive") {
      Helper.alert("Select a workflow to activate", 'error');
      return;
    }
    else if (!workflowid && tab==="Active") {
      Helper.alert("Select a workflow to inactive", 'error');
      return;
    }
    let formData;
    formData = {
      "workflow_id": workflowid,
      "active": tab === 'Active' ? false : true
    }
    let api = Api;
    api.setUserToken()
    api.axios().post(Settings.baseUrl + `workflow/update`, formData).then((res) => {
      if (res.data.success) {
        Helper.alert(res.data.message);
        refreshParentGrid();
      };
    }).catch((error) => {
      console.log(error);
    })
  }

  const onDeleteWorkflow = useCallback(async (element) => {
    let api = Api
    api.setUserToken()
    try {
      let api = Api;
      api.setUserToken()
      const res = await api.axios().post(Settings.baseUrl + 'workflow/delete', {
        template_id: element?.data?.template_id,
        tenant_id: props?.user?.tenant_id
      })
      const rowNode = gridApiActive?.api?.getRowNode(element?.data?.template_id)
      if (rowNode) {
        rowNode.setSelected(false)
      }

      setTimeout(() => {
        const transaction = { remove: [element.data] }
        gridApiActive?.api?.applyServerSideTransaction(transaction)
      }, 200);

      gridApiActive?.api?.refreshServerSide({ purge: true });
      gridApiActive?.api?.deselectAll();

      Helper.alert(res?.data?.message, 'success')
    } catch (err) {
      getPopupMessageBasedOnStatus(err);
    }
  }, []);

  const getTransformedObjForExport = (data) => transformObjectWorkflows(data, dropdownTemplates);

  const exportData = async (isWorkflowActive=true) => {
    setExportLoading(true);

    let apiUrl;
    if(isWorkflowActive) {
      apiUrl = Settings.baseUrl + `workflow/get/active`;
    } else {
      apiUrl = Settings.baseUrl + `workflow/get/inactive`
    }
    const params = `?tenant_id=${props?.user?.tenant_id}`;

    let pagination = false;
    let defaultAdvanceFilterObj = false; 

    const baseUrl = generateBaseUrl({ gridObj: gridApiActive, apiUrl, params, pagination, defaultAdvanceFilterObj });
    await exportToXlsx({ url: baseUrl, columns: (gridColumnHeader), apiTokenRequired: false, fileName: isWorkflowActive ? "active_workflow_details" : "inactive_workflow_details", additionalFunction: getTransformedObjForExport });
    
    setExportLoading(false);
  };

  const tabSelectionHandler = (e) => {
    setTab(e);
    setTemplateid(null);
    setWorkflowid(null);
  }
  if(!localStorage.getItem("isWorkflow")){
    localStorage.removeItem("isWorkflowversion")
    localStorage.removeItem("templateId")
   }
  return (
    <>
      {exportLoading ? <NewOverlayLoader /> : null}
      {newWorkflowModal ? <NewWorkflow hideNewWorkflow={setNewWorkflow} templateData={templateData} tenantId={props?.user?.tenant_id} /> : ""}
      {triggerOption ? <TriggerOption hideTriggerOption={setTriggerOption} workflowid={workflowid} templateid={templateid} /> : ""}
      {workflowVersionsModal ? <WorkflowVersions hideWorkflowVersions={setWorkflowVersions} templateId={templateid} setTemplateid={setTemplateid} /> :
        <>
          <NavigationHeder hideBackButton={true} title={`<span style="color:#000;"> Home > </span>  ${`${tab} Workflows`}`}>
            {/* <Button icon={'/images/icons/delete.svg'} onClick={workflowDeleteWithAllVersion} /> */}
            <Button title={tab === 'Active' ? 'Inactive' : 'Active'} onClick={workflowActiveHandler} icon={'/images/icons/edit.svg'} />
            <Button title="Design" icon={'/images/icons/eye.svg'} onClick={designHandler} />
            <Button title="Version" icon={'/images/icons/finance.svg'} onClick={workflowVersionHandler} />
            <Button isActive={true} title="Workflow" icon={'/images/icons/plus-white.svg'} onClick={() => setNewWorkflow(true)} />
          </NavigationHeder>

          <div className='dashboard-nav-main'>
            <Tabs
              defaultActiveKey={tab}
              className="mt-4 mb-4 border-bottom"
              onSelect={tabSelectionHandler}
            >
              <Tab className='mb-4' eventKey="Active" title="Active">
                {tab === 'Active' &&
                  <div className='rs_form_grid'>
                    <AgGridNew
                      apiUrl={Settings.baseUrl + `workflow/get/active`}
                      additionalParams={`?tenant_id=${props?.user?.tenant_id}`} // change this ? to & once pagination is true
                      filterAdditionalParams={`?tenant_id=${props?.user?.tenant_id}`} // change this ? to & once pagination is true
                      pagination={false}
                      columnDefs={gridColumnHeader} 
                      hideDeleteBtn={true}
                      onSelectionChanged={getRowData}
                      handleDeleteSelectedRows={onDeleteWorkflow}
                      height={500}
                      apiTokenRequired={false}
                      hideDeleteBtn={true}
                      hideAddBtn={true}
                      onGridReady={(params) => gridApiActive = params} 
                      uniqueField={`template_id`}
                      gridId={'rs_workflow_active_grid'}
                      rowType={'single'}
                      afterDeleteBtns={
                        <div className="import_sample_template px-2 ms-auto">
                          <button onClick={exportData}>
                            <img className="img-fluid" src="/images/icons/excel-logo.svg" alt="excel-logo" /> Export
                          </button>
                        </div>
                      }
                      btnsWrapperStyle="w-100 px-2"
                    />
                  </div>
                }
              </Tab>
              <Tab className='mb-4' eventKey="Inactive" title="Inactive"> 
                {tab === 'Inactive' &&
                  <div className='rs_form_grid'>
                    <AgGridNew
                      apiUrl={Settings.baseUrl + `workflow/get/inactive`}
                      additionalParams={`?tenant_id=${props?.user?.tenant_id}`} // change this ? to & once pagination is true
                      filterAdditionalParams={`?tenant_id=${props?.user?.tenant_id}`} // change this ? to & once pagination is true
                      pagination={false}
                      columnDefs={gridColumnHeader} 
                      onSelectionChanged={getRowData}
                      hideDeleteBtn={true}
                      handleDeleteSelectedRows={onDeleteWorkflow}
                      height={500}
                      hideDeleteBtn={true}
                      apiTokenRequired={false}
                      hideAddBtn={true}
                      onGridReady={(params) => gridApiActive = params} 
                      uniqueField={`template_id`}
                      gridId={'rs_workflow_active_grid'}
                      rowType={'single'}
                      afterDeleteBtns={
                        <div className="import_sample_template px-2 ms-auto">
                          <button onClick={() => exportData(false)}>
                            <img className="img-fluid" src="/images/icons/excel-logo.svg" alt="excel-logo" /> Export
                          </button>
                        </div>
                      }
                      btnsWrapperStyle="w-100 px-2"
                    />
                    {/* <AgGridMemo data={inactiveWorkFlowData} header={gridColumnHeader} onDelete={deleteWorkflow} onSelectionChanged={getRowData} singleRowSelect={true} viewOnly={true} forceRender={inActiveForceRender} addBtnHide={true} /> */}
                  </div>
                }
              </Tab>
            </Tabs>
          </div>
        </>
      }
    </>
  )
} 

const mapStateToProps = (state) => {
  return { 
    user: state.auth.user
  }
};

export default connect(mapStateToProps) (MasterComponentWraper(Workflow));